<template>
    <div class="home-container" ref="container">
        <div style="padding-top: 50px;">
            <div class="header">
                <div class="titles">
                    <h1 class="title">养老机构运营平台</h1>
                </div>
                <!-- <div class="out">
                    <el-button icon="el-icon-switch-button">退出</el-button>
                </div> -->
            </div>
            <div class="content" :style="conHeight">
                <div class="contents">
                    <el-row justify='center'>
                        <el-col :md='6' :xl="{span:'4-8'}" v-for="(item,i) in openList" :key="i">
                            <div class="boxTop" @click="open(item.top,item.url)">
                                <img class="backImg" :src="itemImg"/>
                                <img class="itemImg" :src="item.img"/>
                                <div class="topName"><span>{{item.name}}</span></div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <div>

        </div>
    </div>
</template>

<script>
    import 'echarts-liquidfill'
    export default {
        name: "Home",
        data(){
            return{
                GetSumTotal:'0',
                GetSumAddBalance:'0',
                GetSumNumber:'0',
                PatientNumber:'0',
                GetNumberByWares:'0',
                jican:require('./img/jican.png'),
                itemImg:require('./img/item.png'),
                laoren:require('./img/laoren.png'),
                shanshi:require('./img/shanshi.png'),
                shebei:require('./img/shebei.png'),
                jiedai:require('./img/jiedai.png'),
                jilu:require('./img/jilu.png'),
                shijian:require('./img/shijian.png'),
                huli:require('./img/huli.png'),
                ruyuan:require('./img/ruyuan.png'),
                zichan:require('./img/zichan.png'),
                yiliao:require('./img/yiliao.png'),
                xiaofang:require('./img/xiaofang.png'),
                caiwu:require('./img/caiwu.png'),
                Percent:'0',
                userTypeValue:['默认','老人','子女','医生','护士','护工','员工','保安'],
                chartData: [
                    {level: '药品入库', landArea: 0},
                    {level: '药品出库', landArea: 0},
                    {level: '物品入库', landArea: 0},
                    {level: '物品出库', landArea: 0},
                ],
                openList:[
                ],
                chartData1: [],
                tableData:[],
                tableData1:[],
                conHeight:{
                    height:''
                },
                nameList:['机构管理','老人档案','膳食管理','设备管理','接待管理','记录管理','事件管理','护理管理','入院管理','资产管理','医疗管理','消防管理','财务管理'],
                imgList:[],
                loading:'',
            }
        },
        mounted(){
            this.$nextTick(()=>{ // 页面渲染完成后的回调
                this.conHeight.height=this.$refs.container.offsetHeight-150+'px'
            })
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(){
                this.conHeight.height=this.$refs.container.offsetHeight-150+'px'
            },
            '$store.state.listMenuDTO' : function(val){
                // console.log(val)
                this.openList=this.getOpenList(val,[])
                this.openList=this.getOpenList1(this.openList)
                if(this.loading)this.loading.close();
            },
        },
        created(){
           this.init()
        },
        methods:{
            init(){
                this.imgList=[this.jican,this.laoren,this.shanshi,this.shebei,
                this.jiedai,this.jilu,this.shijian,this.huli
                ,this.ruyuan,this.zichan,this.yiliao,this.xiaofang
                ,this.caiwu]
                let listMenuDTO=this.$store.state.listMenuDTO
                if(listMenuDTO){
                    this.openList=this.getOpenList(listMenuDTO,[])
                    this.openList=this.getOpenList1(this.openList)
                }else{
                    this.loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                }
            },
            getOpenList1(openList){
                var list=[]
                for(var i in this.nameList){
                    var data={img:this.imgList[i],name:this.nameList[i],url:'',top:''}
                    for(var j in openList){
                        if(openList[j].name==this.nameList[i]){
                            data.url=openList[j].url
                            data.top=openList[j].top
                        }
                    }
                    list.push(data)
                }
                return list;
            },
            getOpenList(list,openList){
                for(var i in list){
                    let index=this.nameList.indexOf(list[i].name)
                    if(index!=-1){
                        let url=list[i].listMenuDTO[0].listMenuDTO.length>0?list[i].listMenuDTO[0].listMenuDTO[0].url:list[i].listMenuDTO[0].url
                        openList.push({img:this.imgList[index],name:list[i].name,url:url,top:list[i].url})
                    }
                    let list1=list[i].listMenuDTO
                    for(var j in list1){
                        let index1=this.nameList.indexOf(list1[j].name)
                        if(index1!=-1){
                            let url=list1[j].listMenuDTO.length>0?list1[j].listMenuDTO[0].url:list1[j].url
                            openList.push({img:this.imgList[index1],name:list1[j].name,url:url,top:list[i].url})
                        }
                    }
                }
                return openList
            },
            open(top,url){
                if(top&&url){
                    this.$store.commit('update', ['activeMenuTop',top]);
                    window.localStorage.setItem('activeMenuTop', top);
                    this.$router.push({ path: url })
                }
            },
        }

    }


</script>

<style lang="scss"  scoped>
    .home-container {
        min-height: 100%;
        width: 100%;
        background-image: url(./img/back.jpg);
        background-size: cover;
        -webkit-background-size: cover;
        -o-background-size: cover;
        background-position: center 0;
        margin-top: -50px;height: 100vh;
        .header{
            width: 90vw;
            margin:0 auto;
            height: 80px;
            background: -webkit-gradient(linear, 0 0, 0 100%, from(#021D46), to(#023171));
            border-bottom-right-radius:135px 100px;
            border-bottom-left-radius:135px 100px;
            padding: 10px 0;
            text-align: center;
        }
        .content{
            height: 100%;
            width: 100%;
            padding: 0;
            display: flex;
            align-items: center; /*定义body的元素垂直居中*/
            justify-content: center; /*定义body的里的元素水平居中*/
        }
        .contents{
            width: 100%;
            padding: 50px;
            transform: translate(0,-10%);
            
        }
        .topName{
            line-height: 92px;
            font-size: 32px;
            position: relative; 
            display: inline-block;
        }
        .topNumber{
            font-size: 36px;
            font-weight: bold;
        }
        .backImg{
            width: 100%;
            z-index: 0;
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
        }
        
      
        .boxTop{
            overflow: hidden;
            border-radius: 6px;
            color: #1FE1F7;
            text-align: center;
            padding: 5px 0;
            margin: 20px 27px;
            position: relative;
            cursor:pointer
        }
        .itemImg{
            transform: translate(0,4px);
            margin-right: 10px;
        }
        .title{
            background: linear-gradient(to top, #067DC9, #18F2FB);
            background-clip: text;
            margin: 0;
            color: transparent;
            font-size: 42px;
        }
        .out{
            position: absolute;
            margin-right: 100px;
            right: 101px;
            top: 34px;
        }
        .out button{
            background: transparent;
            color: #1FE1F8;
            font-size: 16px;
            border-color: #1FE1F8;
        }
        .titles{
            height: 80px;
            line-height: 80px;
            width: 500px;
            margin: 0 auto;
        }
        .el-col-xl-4-8 {
            width: 20%;
        }
    }
    
</style>
